export const USER_ROUTES = {
  DIRECT_MESSAGES: '/user/inbox/direct-messages',
  INBOX: '/user/inbox',
  OFFERS: '/user/offers',
  POSTS: '/user/posts',
  SETTINGS: '/user/settings/profile',
  SHIPMENT_CHATS: '/user/inbox/shipment-chats',
  SHIPMENTS: '/user/shipments',
  SINGLE_SHIPMENT: (shipmentID: string) => `/user/shipments/${shipmentID}`,
  TEAM_MEMBER_CHATS: '/user/inbox/team-member-chats',
  WORKSPACES: '/user/settings/workspaces'
}
export const WORKSPACE_ROUTES = {
  APP_DOWNLOAD: (workspaceName: string) => `/${workspaceName}/app-download-configuration`,
  APPLICATIONS: (workspaceName: string) => `/${workspaceName}/settings/apps`,
  AUTOPILOT: (workspaceName: string) => `/${workspaceName}/autopilot`,
  BOOKING_AGENT: (workspaceName: string) => `/${workspaceName}/autopilot/booking-agent`,
  CARRIER_HUB_SETTINGS: (workspaceName: string) => `/${workspaceName}/settings/carrier-hub-settings`,
  CONTAINERS: (workspaceName: string) => `/${workspaceName}/containers`,
  NETWORK_DASHBOARD: (workspaceName: string) => `/${workspaceName}/network/dashboard`,
  NETWORK_LANES: (workspaceName: string) => `/${workspaceName}/network/lanes`,
  NETWORK_CONNECTIONS: (workspaceName: string) => `/${workspaceName}/network/connections`,
  CUSTOMER_URL: (workspaceName: string, customerName: string, status?: string[]) => {
    const params: string[] = [`customerName=${encodeURIComponent(customerName)}`]
    if (status && status.length > 0) {
      const statusValues = status.map((s) => encodeURIComponent(s)).join(',')
      params.push(`status=${statusValues}`)
    }
    return `/${workspaceName}/public/shipment/tracking?${params.join('&')}`
  },
  DEVELOPERS_SETTINGS: (workspaceName: string) => `/${workspaceName}/settings/developers`,
  EMAIL_CONFIGURATION: (workspaceName: string) => `/${workspaceName}/settings/email-configuration`,
  EXCLUSIONS: (workspaceName: string) => `/${workspaceName}/settings/exclusions`,
  INTEGRATIONS: (workspaceName: string) => `/${workspaceName}/settings/integrations`,
  LOGS: (workspaceName: string) => `/${workspaceName}/settings/logs`,
  MEMBERS: (workspaceName: string) => `/${workspaceName}/settings/members`,
  NETWORK: (workspaceName: string) => `/${workspaceName}/network`,
  NOTIFICATIONS: (workspaceName: string) => `/${workspaceName}/settings/notifications`,
  OFFERS: (workspaceName: string) => `/${workspaceName}/offers`,
  POSTS: (workspaceName: string) => `/${workspaceName}/posts`,
  PUBLIC_POSTS: (workspaceName: string) => `/${workspaceName}/public/posts`,
  REPORTS: (workspaceName: string) => `/${workspaceName}/settings/reports`,
  SETTINGS: (workspaceName: string) => `/${workspaceName}/settings`,
  SHIPMENTS: (workspaceName: string) => `/${workspaceName}/shipments`,
  SINGLE_SHIPMENT: (workspaceName: string, shipmentID: string) => `/${workspaceName}/shipments/${shipmentID}`,
  TRACKING_AGENT: (workspaceName: string) => `/${workspaceName}/autopilot/tracking-agent`,
  VOICE_BOT: (workspaceName: string) => `/${workspaceName}/voice-bot`,
  VOICE_BOT_REPORTS: (workspaceName: string) => `/${workspaceName}/voice-bot/reports`
}
export const AUTH_ROUTES = {
  CARRIER_ONBOARDING: '/carrier-onboarding',
  LOGIN: '/login',
  ONBOARDING: '/onboarding',
  PROFILE_PICTURE: '/onboarding/profile-picture',
  VERIFY: '/verify'
}

export const PUBLIC_ROUTES = {
  API_DOCS: 'https://handbook.chaineapp.com/api/home',
  HELP_CENTER: 'https://help.trychain.com/en/'
}

export const EMBED_ROUTES = {
  CHAT: '/embed/chat',
  MAP: '/embed/map'
}
